import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item', 'image']

  toggle(event) {
    const item = event.currentTarget.closest(
      '.img-highlights-v3-accordion__item'
    )
    const index = this.itemTargets.indexOf(item)
    if (index === -1) return

    this.open(index)
  }

  open(index) {
    this.itemTargets.forEach((el, i) => {
      const expanded = i === index
      el.classList.toggle('img-highlights-v3-accordion__item--open', expanded)
      el.querySelector('button').setAttribute('aria-expanded', expanded)
    })

    this.imageTargets.forEach((el, i) => {
      el.classList.toggle('img-highlights-v3__img-wrap--active', i === index)
    })
  }
}
